import { useState } from "react";
import ContainerSize from "../../Components/container";
import NavBar from "../../Components/NavBar";
import SEO from "../../Components/SEO"

const Events = () => {
  const images = [
    { src: "images/events/8.jpeg", alt: "Event 8" },
    { src: "images/events/1.jpeg", alt: "Event 1" },
    { src: "images/events/2.jpeg", alt: "Event 2" },
    { src: "images/events/3.jpeg", alt: "Event 3" },
    { src: "images/events/4.jpeg", alt: "Event 4" },
    { src: "images/events/5.jpeg", alt: "Event 5" },
    { src: "images/events/6.jpeg", alt: "Event 6" },
    { src: "images/events/7.jpeg", alt: "Event 7" },
    { src: "images/events/9.jpeg", alt: "Event 9" },
    { src: "images/events/10.jpeg", alt: "Event 10" },
    { src: "images/events/11.jpeg", alt: "Event 11" },
    //  { src: "images/events/12.jpeg", alt: "Event 1" },
  ];

  const [selectedIndex, setSelectedIndex] = useState(null);
  const [loadedImages, setLoadedImages] = useState({});

  const handleImageLoad = (index) => {
    setLoadedImages((prev) => ({ ...prev, [index]: true }));
  };

  const handlePrev = () => {
    setSelectedIndex((prev) =>
      prev === 0 ? images.length - 1 : prev - 1
    );
  };

  const handleNext = () => {
    setSelectedIndex((prev) =>
      prev === images.length - 1 ? 0 : prev + 1
    );
  };

  return (
    <>
    <SEO
        title="Insurance Industry Events USA | IMASH Insure"
        description="Explore IMASH Insure’s insurance industry events, webinars, and conferences across the USA, connecting insurance agencies with outsourcing insights and best practices."
      />
      <NavBar
        title="EVENTS"
        image="/images/event-page.jpg"
        description="Stay updated on our latest industry events."
      />

      <ContainerSize>
        
        <div className="flex flex-wrap justify-center gap-4 py-[60px]">
          {images.map((img, index) => (
            <div key={index} className="relative">
              {!loadedImages[index] && (
                <div className="w-70 h-60 bg-gray-300 animate-pulse rounded-lg" />
              )}

              <img
                src={img.src}
                alt={img.alt}
                className={`w-70 h-60 object-cover rounded-lg cursor-pointer transition-opacity duration-500 ${
                  loadedImages[index]
                    ? "opacity-100"
                    : "opacity-0 absolute"
                }`}
                onClick={() => setSelectedIndex(index)}
                onLoad={() => handleImageLoad(index)}
              />
            </div>
          ))}
        </div>

        
        {selectedIndex !== null && (
          <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
            <div className="relative flex items-center gap-6">

              {/* LEFT BUTTON */}
              <button
                onClick={handlePrev}
                className="text-white text-4xl px-4 hover:scale-110 transition"
              >
                ❮
              </button>

              {/* IMAGE */}
              <img
                src={images[selectedIndex].src}
                alt={images[selectedIndex].alt}
                className="max-w-[90vw] max-h-[80vh] rounded-lg"
              />

              {/* RIGHT BUTTON */}
              <button
                onClick={handleNext}
                className="text-white text-4xl px-4 hover:scale-110 transition"
              >
                ❯
              </button>

              {/* CLOSE BUTTON */}
              <button
                onClick={() => setSelectedIndex(null)}
                className="absolute top-6 right-[110px] bg-black text-black p-2 rounded-full h-[50px] w-[50px] shadow-md hover:bg-gray-600"
              >
                <p className="text-white">
✕
                </p>
                
              </button>

            </div>
          </div>
        )}
      </ContainerSize>
    </>
  );
};

export default Events;
